import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzDividerModule } from "ng-zorro-antd/divider";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzSpinModule } from "ng-zorro-antd/spin";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { AdminApiTokensComponent } from "./admin-api-tokens.component";
import { AdminApiTokenRevealModule } from "./admin-api-token-reveal/admin-api-token-reveal.module";

@NgModule({
  declarations: [AdminApiTokensComponent],
  imports: [
    CommonModule,
    TranslateModule,
    NzButtonModule,
    NzDividerModule,
    NzIconModule,
    NzModalModule,
    NzSpinModule,
    NzTableModule,
    NzToolTipModule,
    AdminApiTokenRevealModule,
  ],
})
export class AdminApiTokensModule {}
